import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b66b5b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("PM")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2.5", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("PM")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "10", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("SO")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("NO")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("O")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "3", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "avg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table", true)!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
      default: _withCtx(() => [
        _createVNode(_component_Table, {
          columns: _ctx.columns.tableColumns,
          pagination: {
          pageSize: 10,
          size: 'small',
          showQuickJumper: true,
          showTotal: (total) => `共 ${total} 条`,
        },
          scroll: {
          x: '18rem',
          y: '6.35rem'
        },
          "data-source": _ctx.tableData,
          rowKey: "index"
        }, {
          index: _withCtx(({ index,}) => [
            _createElementVNode("span", null, _toDisplayString(index + 1), 1)
          ]),
          issue: _withCtx(({ text,}) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.formatTime(text)), 1)
          ]),
          type: _withCtx(() => [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("span", null, "AQI", 512), [
                [_vShow, _ctx.paramType === 'aqi']
              ]),
              _withDirectives(_createElementVNode("span", null, _hoisted_4, 512), [
                [_vShow, _ctx.paramType === 'pm25']
              ]),
              _withDirectives(_createElementVNode("span", null, _hoisted_7, 512), [
                [_vShow, _ctx.paramType === 'pm10']
              ]),
              _withDirectives(_createElementVNode("span", null, _hoisted_10, 512), [
                [_vShow, _ctx.paramType === 'so2']
              ]),
              _withDirectives(_createElementVNode("span", null, _hoisted_13, 512), [
                [_vShow, _ctx.paramType === 'no2']
              ]),
              _withDirectives(_createElementVNode("span", null, _hoisted_16, 512), [
                [_vShow, _ctx.paramType === 'o3']
              ]),
              _withDirectives(_createElementVNode("span", null, "CO", 512), [
                [_vShow, _ctx.paramType === 'co']
              ]),
              _withDirectives(_createElementVNode("span", null, "TVOC", 512), [
                [_vShow, _ctx.paramType === 'tvoc']
              ])
            ])
          ]),
          data: _withCtx(({ text }) => [
            (_ctx.paramType !== 'tvoc')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle({
            'height': '0.24rem',
            'width': '0.5rem',
            'margin': '0 auto',
            'border-radius': '0.04rem',
            'line-height': '0.24rem',
            'background-color': _ctx.factorColorRender(text === null ? -9999 : Number(text), _ctx.paramType),
            'color': _ctx.fontColorRender(Number(text), _ctx.paramType)
          })
                }, _toDisplayString(Number(text) === -9999 ? '--' : text), 5))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(Number(text) === -9999 ? '--' : text), 1))
          ]),
          aqi: _withCtx(({ text }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({
            'height': '0.24rem',
            'width': '0.5rem',
            'margin': '0 auto',
            'border-radius': '0.04rem',
            'line-height': '0.24rem',
            'background-color': _ctx.factorColorRender(text === null ? -9999 : Number(text), 'aqi'),
            'color': _ctx.fontColorRender(Number(text), 'aqi')
          })
            }, _toDisplayString(Number(text) === -9999 ? '--' : text), 5)
          ]),
          pm25: _withCtx(({ text }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({
            'height': '0.24rem',
            'width': '0.5rem',
            'margin': '0 auto',
            'border-radius': '0.04rem',
            'line-height': '0.24rem',
            'background-color': _ctx.factorColorRender(text === null ? -9999 : Number(text), 'pm25'),
            'color': _ctx.fontColorRender(Number(text), 'pm25')
          })
            }, _toDisplayString(Number(text) === -9999 ? '--' : text), 5)
          ]),
          pm10: _withCtx(({ text }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({
            'height': '0.24rem',
            'width': '0.5rem',
            'margin': '0 auto',
            'border-radius': '0.04rem',
            'line-height': '0.24rem',
            'background-color': _ctx.factorColorRender(text === null ? -9999 : Number(text), 'pm10'),
            'color': _ctx.fontColorRender(Number(text), 'pm10')
          })
            }, _toDisplayString(Number(text) === -9999 ? '--' : text), 5)
          ]),
          so2: _withCtx(({ text }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({
            'height': '0.24rem',
            'width': '0.5rem',
            'margin': '0 auto',
            'border-radius': '0.04rem',
            'line-height': '0.24rem',
            'background-color': _ctx.factorColorRender(text === null ? -9999 : Number(text), 'so2'),
            'color': _ctx.fontColorRender(Number(text), 'so2')
          })
            }, _toDisplayString(Number(text) === -9999 ? '--' : text), 5)
          ]),
          no2: _withCtx(({ text }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({
            'height': '0.24rem',
            'width': '0.5rem',
            'margin': '0 auto',
            'border-radius': '0.04rem',
            'line-height': '0.24rem',
            'background-color': _ctx.factorColorRender(text === null ? -9999 : Number(text), 'no2'),
            'color': _ctx.fontColorRender(Number(text), 'no2')
          })
            }, _toDisplayString(Number(text) === -9999 ? '--' : text), 5)
          ]),
          o3: _withCtx(({ text }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({
            'height': '0.24rem',
            'width': '0.5rem',
            'margin': '0 auto',
            'border-radius': '0.04rem',
            'line-height': '0.24rem',
            'background-color': _ctx.factorColorRender(text === null ? -9999 : Number(text), 'o3'),
            'color': _ctx.fontColorRender(Number(text), 'o3')
          })
            }, _toDisplayString(Number(text) === -9999 ? '--' : text), 5)
          ]),
          co: _withCtx(({ text }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({
            'height': '0.24rem',
            'width': '0.5rem',
            'margin': '0 auto',
            'border-radius': '0.04rem',
            'line-height': '0.24rem',
            'background-color': _ctx.factorColorRender(text === null ? -9999 : Number(text), 'co'),
            'color': _ctx.fontColorRender(Number(text), 'co')
          })
            }, _toDisplayString(Number(text) === -9999 ? '--' : text), 5)
          ]),
          tvoc: _withCtx(({ text }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({
            'width': '0.5rem',
            'height': '0.24rem',
            'margin': '0 auto',
            'text-align': 'center',
            'border-radius': '0.04rem',
            'line-height': '0.24rem',
            'background-color': (!text ||text === null)  ? '#9b9b9b' : '',
            'color':(!text ||text === null)  ? '#716f6f' : '#000000d9'
          })
            }, _toDisplayString((text && text!== -9999) ? text : '--'), 5)
          ]),
          avg: _withCtx(({ text }) => [
            _createElementVNode("span", _hoisted_18, _toDisplayString(text), 1)
          ]),
          _: 1
        }, 8, ["columns", "pagination", "scroll", "data-source"])
      ]),
      _: 1
    }, 8, ["locale"])
  ]))
}